(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('InsertObjectMappingType', InsertObjectMappingType);

    InsertObjectMappingType.$inject = ['$state', '$uibModalInstance'];

    function InsertObjectMappingType($state, $uibModalInstance) {
        var vm = this;
        vm.property = "";

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.save = function () {
            localStorage.setItem("insert-new-object", JSON.stringify(vm.property));
            $uibModalInstance.close();
        };

    }
})();
